export const createTypographyOptions = (tokens) => {
    const { fontFamily: coreFontFamily } = tokens.core;
    const { color: semanticColor, fontSize: semanticFontSize, fontWeight: semanticFontWeight, lineHeight: semanticLineHeight, letterSpacing: letterSpacing, textTransform: textTransform, } = tokens.semantic;
    return {
        htmlFontSize: 16,
        fontFamily: coreFontFamily.sourceSansPro.value,
        fontSize: 14,
        color: semanticColor.text.body.value,
        fontWeightRegular: semanticFontWeight.regular.value,
        fontWeightMedium: semanticFontWeight.emphasis.value,
        fontWeightBold: semanticFontWeight.link.value,
        h1: {
            fontSize: semanticFontSize.title.display.value,
            lineHeight: semanticLineHeight.title.display.value,
            fontWeight: semanticFontWeight.regular.value,
        },
        h2: {
            fontSize: semanticFontSize.title.lg.value,
            lineHeight: semanticLineHeight.title.lg.value,
            fontWeight: semanticFontWeight.regular.value,
        },
        h3: {
            fontSize: semanticFontSize.title.md.value,
            lineHeight: semanticLineHeight.title.md.value,
            fontWeight: semanticFontWeight.regular.value,
        },
        h4: {
            fontSize: semanticFontSize.title.sm.value,
            lineHeight: semanticLineHeight.title.sm.value,
            fontWeight: semanticFontWeight.regular.value,
        },
        billboard: {
            fontFamily: coreFontFamily.sourceSansPro.value,
            fontSize: semanticFontSize.title.billboard.value,
            lineHeight: semanticLineHeight.title.billboard.value,
            fontWeight: semanticFontWeight.light.value,
        },
        textMd: {
            fontFamily: coreFontFamily.sourceSansPro.value,
            fontSize: semanticFontSize.text.md.value,
            lineHeight: semanticLineHeight.text.md.value,
            fontWeight: semanticFontWeight.regular.value,
        },
        textSm: {
            fontFamily: coreFontFamily.sourceSansPro.value,
            fontSize: semanticFontSize.text.sm.value,
            lineHeight: semanticLineHeight.text.sm.value,
            fontWeight: semanticFontWeight.regular.value,
        },
        textXs: {
            fontFamily: coreFontFamily.sourceSansPro.value,
            fontSize: semanticFontSize.text.xs.value,
            lineHeight: semanticLineHeight.text.xs.value,
            fontWeight: semanticFontWeight.regular.value,
        },
        label: {
            fontFamily: coreFontFamily.sourceSansPro.value,
            fontSize: semanticFontSize.label.lg.value,
            lineHeight: semanticLineHeight.label.lg.value,
            fontWeight: semanticFontWeight.regular.value,
            textTransform: textTransform.label.value,
            letterSpacing: letterSpacing.label.value,
        },
        labelSm: {
            fontFamily: coreFontFamily.sourceSansPro.value,
            fontSize: semanticFontSize.label.sm.value,
            lineHeight: semanticLineHeight.label.sm.value,
            fontWeight: semanticFontWeight.regular.value,
            textTransform: textTransform.label.value,
            letterSpacing: letterSpacing.label.value,
        },
        button: {
            textTransform: tokens.component.button.textTransform.value,
        },
        body2: {
            fontSize: semanticFontSize.text.body.value,
            lineHeight: semanticLineHeight.text.body.value,
            fontWeight: semanticFontWeight.regular.value,
        },
    };
};
//# sourceMappingURL=typography.js.map